import { render, staticRenderFns } from "./ChangeAdminForLbSubscription.vue?vue&type=template&id=32c4ba56&scoped=true&"
import script from "./ChangeAdminForLbSubscription.vue?vue&type=script&lang=js&"
export * from "./ChangeAdminForLbSubscription.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAdminForLbSubscription.vue?vue&type=style&index=0&id=32c4ba56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c4ba56",
  null
  
)

export default component.exports